import { createRouter, createWebHistory,createWebHashHistory } from 'vue-router'
import pages from './page'
import IndexView from '@/views/Index'

const routes = [
  {
    path:'/',
    redirect:'/rcmk'
  },
  // {
  //   path:'/index',
  //   redirect:'/index/home'
  // },
  {
    path:'/yinsi',
    component: ()=>import('../views/userMant/yinsi.vue')
  },
  // 公司产品大赛
  {
    path:'/gscpds',
    component: ()=>import('../views/gscpds/gscpds.vue')
  },
  {
    path:'/gscpdslogin',
    component: ()=>import('../views/gscpds/gscpdslogin.vue')
  },
  // RCMK调查表
  {
    path: '/rcmk',
    meta: { title: '回流焊焊接系统诊断与对策问卷调研',description: '感谢您选择我们的服务！我们期待听到您的宝贵意见，您的反馈将帮助我们不断改进，为您提供更好的服务体验。',image: '../assets/rcmk.png',icon:'../assets/rcmk.jpg'},
    component: ()=>import('../views/rcmk/rcmk.vue')
  },
  // RCMK调查表
  {
    path: '/demo',
    meta: { title: '工艺数智化Demo申请',description: '高信息密度的申请将优先获得产线实测档期及研发资源倾斜，建议由工艺/质量主管联合填写。',image: '../assets/rcmk.png',icon:'../assets/rcmk.jpg'},
    component: ()=>import('../views/demo/demo.vue')
  },
  // RCMK调查表登录
  {
    path: '/demologin',
    meta: { title: 'demo申请问卷调登录注册'},
    component: ()=>import('../views/demo/demologin.vue')
  },
  // 工业清洗调查表
  {
    path: '/gyqx',
    meta: { title: '工业清洗调研表',icon:'../assets/gslogo.jpg'},
    component: ()=>import('../views/gyqx/gyqx.vue')
  },
  // 售后生成二维码
  {
    path:'/scewm',
    component: ()=>import('../views/scewm.vue')
  },
  // 公众号生成二维码
  {
    path:'/scewm1',
    meta: { title: '二维码生成' },
    component: ()=>import('../views/scewm1.vue')
  },
  // 销售生成二维码
  {
    path:'/xsscewm',
    meta: { title: '销售二维码生成',icon:'../assets/gslogo.png' },
    component: ()=>import('../views/xsscewm.vue')
  },
  // 售后满意度调研表
  {
    path: '/login3',
    meta: { title: '售后满意度调研',description: '感谢您选择我们的服务！我们期待听到您的宝贵意见，您的反馈将帮助我们不断改进，为您提供更好的服务体验。',image: '../assets/gslogo.png',icon:'../assets/gslogo.png' },
    component: ()=>import('../views/Login3.vue')
  },
  // 客户满意度调研表
  {
    path: '/login4',
    meta: { title: '客户满意度调研',description: '感谢您选择我们的服务！我们期待听到您的宝贵意见，您的反馈将帮助我们不断改进，为您提供更好的服务体验。',image: '../assets/gslogo.png',icon:'../assets/gslogo.png' },
    component: ()=>import('../views/Login4.vue')
  },
  // 报名表
  {
    path: '/bmb',
    meta: { title: 'Vcam热工学沙龙报名表',icon:'../assets/gslogo.png' },
    component: ()=>import('../views/bmb/bmb.vue')
  },
  {
    path: '/nofind',
    component: ()=>import('@/views/404.vue')
  },
  {
    path: '/:path(.*)+',
    redirect: 'nofind'
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
//路由守卫
router.beforeEach((to,from,next)=>{
  // if(to.path=='/demo'){
  //   if(!sessionStorage.getItem('aesKey')){
  //       ElMessage.error('请先登录')
  //       next('/demologin')
  //   }
  // }
  if (to.meta.title) {//网页文字
    document.title = to.meta.title
  } else {
    document.title = '';
  }
  // 网页图标
  const publicPath = process.env.BASE_URL;
  const favicon = to.path === '/rcmk' ? 'favicon.ico' : 'favicon1.ico';
  const link = document.querySelector(
    "link[rel~='icon']"
  );
 
  if (link) {
    link.href = publicPath + favicon;
  } else {
    const newLink = document.createElement('link');
    newLink.rel = 'icon';
    newLink.href = publicPath + favicon;
    document.head.appendChild(newLink);
  }
  next()
})
export default router
